import {Subject} from "rxjs/Subject";
import {IRootScopeService, ITimeoutService} from "angular";
import {IdleEvent, SystemEvent} from "./SystemEvent";
import {IvSidebarService} from "../../components/ui/iv-sidebar/service/IvSidebarService";
import {AppUtil} from "../../js/util/AppUtil";
import {Observable} from "rxjs/Observable";
import {BehaviorSubject, Scheduler} from "rxjs";

export class SystemEventService extends Subject<SystemEvent> {

    public static id = "systemEventService";

    private idle$ = new BehaviorSubject<IdleEvent>(SystemEvent.IDLE_END);

    /** @ngInject */
    public constructor(private $rootScope: IRootScopeService,
                       private ivSidebarService: IvSidebarService,
                       private $timeout: ITimeoutService) {
        super();
        this.init();
    }

    private init() {
        this.$rootScope.$on("IdleStart", () => {
            this.next(SystemEvent.USER_IDLE);
            this.idle$.next(SystemEvent.USER_IDLE);
        });
        this.$rootScope.$on("IdleEnd", () => {
            this.next(SystemEvent.IDLE_END);
            this.idle$.next(SystemEvent.IDLE_END);

        });
        window.addEventListener("resize", AppUtil.debounce(this.windowResize.bind(this), 100));
        this.ivSidebarService.onStateChange().subscribe(this.windowResize.bind(this));
        this.handleWindowVisibility();
    }

    public idle(): Observable<IdleEvent> {
        return this.idle$.asObservable();
    }

    public windowResize() {
        // 500ms delay is due to animations
        this.$timeout(() => this.next(SystemEvent.VIEW_RESIZE), 500);
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
    private handleWindowVisibility() {
        document.addEventListener("visibilitychange", this.visibilityChanged.bind(this), false);
    }

    private visibilityChanged() {
        if (document.hidden) {
            this.next(SystemEvent.WINDOW_BLUR);
        } else {
            this.next(SystemEvent.WINDOW_FOCUS);
        }
    }

    public eventsOfType(event: SystemEvent): Observable<SystemEvent> {
        const stream =  this.filter((evt) => evt === event)
                            .observeOn(Scheduler.async);
        // A bit of a stupid patch to fix the fact that we don't give the window state to the subscriber at the start
        // which can cause them to not have the current state
        if ((event === SystemEvent.WINDOW_FOCUS) || (event === SystemEvent.WINDOW_BLUR)) {
            const state = document.hidden ? SystemEvent.WINDOW_BLUR : SystemEvent.WINDOW_FOCUS;
            return stream.startWith(state);
        } else {
            return stream;
        }
    }
}
